import { render, staticRenderFns } from "./courseLeadersFilters.vue?vue&type=template&id=061e95b8&scoped=true&lang=pug&"
import script from "./courseLeadersFilters.vue?vue&type=script&lang=js&"
export * from "./courseLeadersFilters.vue?vue&type=script&lang=js&"
import style0 from "./courseLeadersFilters.vue?vue&type=style&index=0&id=061e95b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061e95b8",
  null
  
)

export default component.exports